import CalendarSuccessSolidSVG from "@design-system/ui-icons/vanilla/CalendarSuccessSolid"
import { createIcon } from "../createIcon"

export const CalendarSuccessSolidIcon = createIcon(CalendarSuccessSolidSVG)
